<template>
  <v-container>

    <v-overlay class="centered-overlay" v-model="showWishPeriodInput" persistent>
      <WishPeriodInput :period="selectedWishPeriod"
                       @wishperiod-save="saveWishPeriod" @wishperiod-back="back"></WishPeriodInput>
    </v-overlay>

    <v-overlay class="centered-overlay" v-model="showVacationPeriodInput" persistent>
      <VacationPeriodInput :period="selectedVacationPeriod"
                       @vacationperiod-save="saveVacationPeriod" @vacationperiod-back="back"></VacationPeriodInput>
    </v-overlay>
    <div class="d-flex justify-center mt-4">
      <v-btn-toggle v-model="selectedView" class="mb-4" rounded tile mandatory>
        <v-btn variant="outlined" color="primary" value="wdp">WDP</v-btn>
        <v-btn variant="outlined" color="primary" value="up">UP</v-btn>
      </v-btn-toggle>
    </div>

    <div v-if="selectedView === 'wdp'">
      <div class="underline-full w-100">
        <v-row no-gutters>
          <v-col>
            <span>Wunschdienstplan</span>
          </v-col>
          <v-col class="text-right">
            <v-btn @click="createWishPeriod" class="mb-2" icon height="24" width="24">
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div class="w-100 mb-4">
        <v-list>
          <v-list-item
              v-for="item in wishPeriodsSorted"
              :key="item"
              class="item-entry"
          >
            <v-row no-gutters>
              <v-col cols="4" class="h-100">
                <v-row class="ma-0">
                  {{ item.title }}
                </v-row>
                <v-row class="ma-0">
                  <small>{{ item.startDate.toDate().toLocaleDateString('de-DE') }} - {{ item.endDate.toDate().toLocaleDateString('de-DE') }}</small>
                </v-row>
              </v-col>
              <v-col class="ma-0 pa-0" cols="1">
                <v-icon class="pa-0 mx-2" v-if="item.locked">mdi-lock</v-icon>
                <v-icon color="primary" class="pa-0 mx-2" v-else>mdi-lock-open</v-icon>
              </v-col>
              <v-col class="ma-0 pa-0" cols="1">
                <v-icon class="pa-0 mx-2" v-if="item.hidden">mdi-eye-off</v-icon>
                <v-icon color="primary" class="pa-0 mx-2" v-else>mdi-eye-outline </v-icon>
              </v-col>
              <v-col class="ma-0 pa-0" cols="1">
                <v-icon color="primary" class="pa-0 mx-2" v-if="item.readyToUpload">mdi-publish</v-icon>
                <v-icon class="pa-0 mx-2" v-else>mdi-publish</v-icon>
              </v-col>
              <v-col class="ma-0 pa-0" cols="1">
                <v-icon color="primary" class="pa-0 mx-2" v-if="item.readyToDownload">mdi-download</v-icon>
                <v-icon class="pa-0 mx-2" v-else>mdi-download</v-icon>
              </v-col>
              <v-col cols="4" class="d-flex align-center justify-end" >
                <div>
                  <v-tooltip text="Wünsche herunterladen und für ATOSS bereitstellen." location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" class="ma-1" size="32" icon @click="setReadyForUploadWish(item)">
                        <v-icon size="24">mdi-publish</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip text="Fertigen 8WP aus ATOSS einspielen und veröffentlichen." location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props"  class="ma-1" size="32" icon @click="setReadyForDownloadWish(item)">
                        <v-icon size="24">mdi-download</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                      <v-tooltip text="Bearbeiten der Wunschperiode" location="top">
                        <template v-slot:activator="{ props }">
                      <v-btn v-bind="props"  class="ma-1" size="32" icon @click="editWishPeriod(item)">
                        <v-icon size="24">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </div>
    </div>
    
    <div v-if="selectedView === 'up'">
      <div class="underline-full w-100">
        <v-row no-gutters>
          <v-col>
            <span>Urlaubsplanung</span>
          </v-col>
          <v-col class="text-right">
            <v-btn @click="createVacationPeriod" class="mb-2" icon height="24" width="24">
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div class="w-100 mb-4">
        <v-list>
          <v-list-item
              v-for="item in vacationPeriodsSorted"
              :key="item"
              class="item-entry"
          >
            <v-row no-gutters>
              <v-col cols="4" class="h-100">
                <v-row class="ma-0">
                  {{ item.year }}
                </v-row>
                <v-row class="ma-0">
                  <small>Deadline: {{ item.deadline.toDate().toLocaleDateString('de-DE') }}</small>
                </v-row>
              </v-col>
              <v-col class="ma-0 pa-0" cols="1">
                <v-icon class="pa-0 mx-2" v-if="item.locked">mdi-lock</v-icon>
                <v-icon color="primary" class="pa-0 mx-2" v-else>mdi-lock-open</v-icon>
              </v-col>
              <v-col class="ma-0 pa-0" cols="1">
                <v-icon class="pa-0 mx-2" v-if="item.hidden">mdi-eye-off</v-icon>
                <v-icon color="primary" class="pa-0 mx-2" v-else>mdi-eye-outline </v-icon>
              </v-col>
              <v-col class="ma-0 pa-0" cols="1">
                <v-icon color="primary" class="pa-0 mx-2" v-if="item.readyToUpload">mdi-publish</v-icon>
                <v-icon class="pa-0 mx-2" v-else>mdi-publish</v-icon>
              </v-col>
              <v-col class="ma-0 pa-0" cols="1">
                <v-icon color="primary" class="pa-0 mx-2" v-if="item.readyToDownload">mdi-download</v-icon>
                <v-icon class="pa-0 mx-2" v-else>mdi-download</v-icon>
              </v-col>
              <v-col cols="4" class="d-flex align-center justify-end" >
                <div>
                  <v-tooltip text="Wünsche herunterladen und für ATOSS bereitstellen." location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" class="ma-1" size="32" icon @click="setReadyForUploadVacation(item)">
                        <v-icon size="24">mdi-publish</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip text="Daten aus ATOSS einspielen." location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props"  class="ma-1" size="32" icon @click="setReadyForDownloadVacation(item)">
                        <v-icon size="24">mdi-download</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                      <v-tooltip text="Bearbeiten der Wunschperiode" location="top">
                        <template v-slot:activator="{ props }">
                      <v-btn v-bind="props"  class="ma-1" size="32" icon @click="editVacationPeriod(item)">
                        <v-icon size="24">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </div>
    </div>
    
  </v-container>
</template>

<script lang="ts">
import {computed, ref} from 'vue';
import {collection, doc, setDoc} from "firebase/firestore";
import WishPeriodInput from "@/components/WishPeriodInput.vue";
import {useCollection, useFirestore} from "vuefire";
import VacationPeriodInput from "@/components/VacationPeriodInput.vue";
import {createDialog, notifyInfo} from "vuetify3-dialog";

export default {
  name: 'PeriodView',
  components: { WishPeriodInput, VacationPeriodInput },
  setup() {
    const db = useFirestore();
    let wishPeriods = useCollection(collection(db, 'wishPeriods'));
    let vacationPeriods = useCollection(collection(db, 'vacationPeriods'));
    const selectedVacationPeriod = ref(null);
    const selectedWishPeriod = ref(null);
    const selectedView = ref('wdp');
    let showWishPeriodInput = ref(false);
    let showVacationPeriodInput = ref(false);
    const refreshTick = ref(0);
    
    const vacationPeriodsSorted = computed(() => {
      refreshTick.value;
      return vacationPeriods.value.sort((a, b) => b.year - a.year);
    });
    
    const wishPeriodsSorted = computed(() => {
      refreshTick.value; 
      return wishPeriods.value.sort((a, b) => b.startDate - a.startDate);
    });

    const saveWishPeriod = async (period) => {
      showWishPeriodInput.value = false;
      try {
        await setDoc(doc(db, "wishPeriods", period.id.toString()), period, { merge: true });
      }
      catch (e) {
        console.error('Error updating document: ', e);
      }
    };

    const saveVacationPeriod = async (period) => {
      showVacationPeriodInput.value = false;
      try {
        await setDoc(doc(db, "vacationPeriods", period.year.toString()), period, { merge: true });
      }
      catch (e) {
        console.error('Error updating document: ', e);
      }
    };

    const back = async () => {
      showWishPeriodInput.value = false;
      showVacationPeriodInput.value = false;
    };

    const createWishPeriod = () => {
      selectedWishPeriod.value = null;
      showWishPeriodInput.value = true;
    }

    const editWishPeriod = (period) => {
      // Logic to edit the period
      selectedWishPeriod.value = period;
      showWishPeriodInput.value = true;
    };
    
    const setReadyForUploadWish = async (period) => {
      if(!period.locked)
      {
        await notifyInfo('Der Wunschdienstzeitraum muss gesperrt sein um freigegeben zu werden.', {timeout: 1500});
        return;
      }
      
      createDialog({ title: "Wunschperiode freigeben",
        text: `Möchtest du diese Periode für Atoss freigeben?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then(async (answer) => {
            if(answer) {
              period.readyToUpload = true;
              try {
                await setDoc(doc(db, "wishPeriods", period.id.toString()), period, { merge: true });
              }
              catch (e) {
                console.error('Error updating document: ', e);
              }
            }
          }).finally(() => {
              refreshTick.value++;
          })
    };

    const setReadyForDownloadWish = async (period) => {
      if(!period.readyToUpload || !period.locked)
      {
        if(!period.locked)
        {
          await notifyInfo('Der Wunschdienstzeitraum muss gesperrt sein um freigegeben zu werden.', {timeout: 1500});
        }

        if(!period.readyToUpload)
        {
          await notifyInfo('Der Wunschdienstzeitraum muss vor der Synchronisierung freigegeben sein.', {timeout: 1500});
        }
        return;
      }
      
      createDialog({ title: "Wunschperiode herunterladen",
        text: `Möchtest du diese Periode von Atoss synchronisieren?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then(async (answer) => {
            if(answer) {
              period.readyToDownload = true;
              try {
                await setDoc(doc(db, "wishPeriods", period.id.toString()), period, { merge: true });
              }
              catch (e) {
                console.error('Error updating document: ', e);
              }
            }
          }).finally(() => {
        refreshTick.value++;
      })
    };
    
    const createVacationPeriod = () => {
      selectedVacationPeriod.value = null;
      showVacationPeriodInput.value = true;
    }
    
    const editVacationPeriod = (period) => {
      selectedVacationPeriod.value = period;
      showVacationPeriodInput.value = true;
    };
    
    const setReadyForUploadVacation = async (period) => {
      if(!period.locked)
      {
        await notifyInfo('Der Urlaubszeitraum muss gesperrt sein um freigegeben zu werden.', {timeout: 1500});
        return;
      }
      
      createDialog({ title: "Wunschperiode freigeben",
        text: `Möchtest du diese Periode für Atoss freigeben?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then(async (answer) => {
            if(answer) {
              period.readyToUpload = true;
              try {
                await setDoc(doc(db, "vacationPeriods", period.year.toString()), period, { merge: true });
              }
              catch (e) {
                console.error('Error updating document: ', e);
              }
            }
          }).finally(() => {
              refreshTick.value++;
          });
        
      };
    
    const setReadyForDownloadVacation = async (period) => {
      if(!period.readyToUpload || !period.locked)
      {
        if(!period.locked)
        {
          await notifyInfo('Der Urlaubszeitraum muss gesperrt sein um freigegeben zu werden.', {timeout: 1500});
        }
        
        if(!period.readyToUpload)
        {
          await notifyInfo('Der Urlaubszeitraum muss vor der Synchronisierung freigegeben sein.', {timeout: 1500});
        }
        
        return;
      }
      
      createDialog({ title: "Wunschperiode herunterladen",
        text: `Möchtest du diese Periode von Atoss synchronisieren?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then(async (answer) => {
            if(answer) {
              period.readyToDownload = true;
              try {
                await setDoc(doc(db, "vacationPeriods", period.year.toString()), period, { merge: true });
              }
              catch (e) {
                console.error('Error updating document: ', e);
              }
            }
          }).finally(() => {
        refreshTick.value++;
      });

    };

    return { showWishPeriodInput, wishPeriods, vacationPeriods, showVacationPeriodInput, selectedWishPeriod, selectedVacationPeriod, saveWishPeriod, saveVacationPeriod, back, selectedView, createWishPeriod, editWishPeriod,setReadyForUploadWish, setReadyForDownloadWish, createVacationPeriod, editVacationPeriod, setReadyForDownloadVacation, setReadyForUploadVacation,  wishPeriodsSorted, vacationPeriodsSorted };
  }
}
</script>

<style scoped>

.container {
  background-color: #f0f0f0; /* Replace with your desired color */
}

.centered-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}

.underline-full{
  border-bottom: 1px solid black;
  display: block;
}

.item-entry{
  border-bottom: 1px solid black;
  border-color: lightgray;
  margin-top: 2px;
  margin-bottom: 2px;
}

.item-entry:hover{
  background-color: #f0f0f0;
}

.item-entry-disabled{
  opacity: 0.5;
}
</style>

